import { createContext, useContext, type ReactNode } from "react";

interface ApplicantToPayContextValue {
  isApplicantToPay: boolean;
}

const ApplicantToPayContext = createContext<ApplicantToPayContextValue>({
  isApplicantToPay: false,
});

export function ApplicantToPayProvider({
  children,
  isApplicantToPay,
}: {
  children: ReactNode;
  isApplicantToPay: boolean;
}) {
  return (
    <ApplicantToPayContext.Provider value={{ isApplicantToPay }}>
      {children}
    </ApplicantToPayContext.Provider>
  );
}

export function useApplicantToPayContext() {
  return useContext(ApplicantToPayContext);
}
